import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Jamf extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M18.8,4.168c-3.077,0-4.923,1.287-5.762,4.084l-2.126,6.657a4.079,4.079,0,0,1-4.364,3.077H1.231A1.241,1.241,0,0,0,0,19.217v3.412a1.135,1.135,0,0,0,1.175,1.119H22.769A1.241,1.241,0,0,0,24,22.517V5.343a1.147,1.147,0,0,0-1.175-1.175ZM1.287.252A1.34,1.34,0,0,0,0,1.538V10.6a1.266,1.266,0,0,0,1.287,1.287H5.874c2.07,0,4.979-.447,5.762-4.14,0,0,.784-3.748,1.231-5.93A1.29,1.29,0,0,0,11.58.252Z" />
      </svg>
    );
  }
}

export default Jamf;
